// Declared twice so that docs appear when selecting colors
export interface CosmicPalette extends Record<string, string> {
  /** **#DCEAF7** Blue */
  readonly cosmic10: string;
  /** **#BDDAF2** Blue */
  readonly cosmic30: string;
  /** **#83BCEB** Blue */
  readonly cosmic60: string;
  /** **#3393E0** Blue */
  readonly cosmicPrimary: string;
  /** **#0D70BF** Blue */
  readonly cosmic80: string;
  /** **#00447C** Blue */
  readonly cosmic90: string;
}

export const cosmicPalette: CosmicPalette = {
  cosmic10: '#DCEAF7',
  cosmic30: '#BDDAF2',
  cosmic60: '#83BCEB',
  cosmicPrimary: '#3393E0',
  cosmic80: '#0D70BF',
  cosmic90: '#00447C',
};
